module.exports = __webpack_public_path__ + "assets/img/buy_xuele_course2.24eb90b1.png";